import React from 'react';
import {
  LayoutDashboard, Package, ShoppingCart, DoorOpen, Warehouse,
  FileText, TrendingUp, Users, Megaphone, AlertTriangle, Send,
} from 'lucide-react';

// Agrupado por lo que el dueño hace, no por orden de creación: 10 entradas
// seguidas se leen peor que 4 grupos de 2-5.
const GRUPOS = [
  {
    titulo: 'Operación',
    items: [
      { id: 'dashboard', label: 'Dashboard', Icono: LayoutDashboard },
      { id: 'paquetes', label: 'Paquetes', Icono: Package },
      { id: 'compra_asistida', label: 'Compra Asistida', Icono: ShoppingCart },
      { id: 'puerta_puerta', label: 'Puerta a Puerta', Icono: DoorOpen },
      { id: 'prealertas_operador', label: 'Prealertas al Operador', Icono: Send },
      { id: 'operador', label: 'Operador Logístico', Icono: Warehouse },
    ],
  },
  {
    titulo: 'Finanzas',
    items: [
      { id: 'facturas', label: 'Facturas', Icono: FileText },
      { id: 'rentabilidad', label: 'Rentabilidad', Icono: TrendingUp },
    ],
  },
  {
    titulo: 'Clientes',
    items: [
      { id: 'usuarios', label: 'Usuarios', Icono: Users },
      { id: 'leads', label: 'Leads', Icono: Megaphone },
    ],
  },
  {
    titulo: 'Sistema',
    items: [
      { id: 'errores', label: 'Errores', Icono: AlertTriangle, tono: 'alerta' },
    ],
  },
];

/**
 * Menú lateral del admin. `badges` es { idDeSeccion: cantidad }: solo se
 * muestra la insignia cuando la cantidad es mayor que 0.
 */
export default function AdminSidebar({ tab, onChange, badges = {} }) {
  return (
    <aside className="admin-sidebar">
      <nav className="admin-sidebar__inner" aria-label="Secciones del panel">
        {GRUPOS.map((grupo) => (
          <div className="admin-sidebar__grupo" key={grupo.titulo}>
            <div className="admin-sidebar__titulo">{grupo.titulo}</div>
            {grupo.items.map(({ id, label, Icono, tono }) => {
              const cantidad = badges[id] || 0;
              return (
                <button
                  key={id}
                  type="button"
                  className={`admin-sidebar__item ${tab === id ? 'is-active' : ''}`}
                  aria-current={tab === id ? 'page' : undefined}
                  onClick={() => onChange(id)}
                >
                  <Icono size={16} aria-hidden="true" />
                  <span className="admin-sidebar__label">{label}</span>
                  {cantidad > 0 && (
                    <span className={`admin-sidebar__badge ${tono === 'alerta' ? 'is-alerta' : ''}`}>
                      {cantidad}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        ))}
      </nav>
    </aside>
  );
}
